module.exports = __webpack_public_path__ + "img/dlt.a7a90e78.svg";